import axios from 'axios';
import {HomePageProducts} from './types';

export const save = (homePageProducts: HomePageProducts) => axios.put(
    // NOTE: This is an OWNER api, not an ADMIN api!
    '/api/pws/site-settings-section/current/homePageProducts',
    homePageProducts
);
